<div class="container advantage-container">

  <app-section-heading [label]="'Miért a Gesztenye Liget Lakópark?'" [light]="true"></app-section-heading>


  <div class="row">

    <div class="col-12 col-md-6" *ngFor="let marketingItem of marketingItems; let i = index">

      <app-marketing-item [marketingItem]="marketingItem"></app-marketing-item>
    </div>


  </div>


</div>
